export const FINANCIAL_INFORMATION_DRAFT = 'financialInformationDraft';
export const FINANCIAL_INFORMATION_DRAFT_TIME = 3000;
export const FINANCIAL_INFORMATION_DRAFT_EXPIRE_AFTER = 30; // day
